@use '../../styles/variables.scss' as *;
.docs-story,
.sb-show-main.sb-main-centered {
  background-color: var(--story-bkgd);
}
.button {
  font-family: $font-family;
  font-style: normal;
  font-weight: 600;
  border-radius: 4px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  cursor: pointer;
  span {
    margin: 0px;
    display: inline-block;
  }
  &:focus {
    box-shadow: none;
  }
  &:focus-visible {
    box-shadow:
      0 0 0 2px $pcl-main-bkgd,
      0 0 0 4px $focus-ring-soft,
      0 1px 2px 0 black;
    outline: none;
  }
  &:disabled,
  &.Disabled {
    cursor: default;
    pointer-events: none;
  }
  &:not(:has(label)) {
    padding: 0;
    border-color: transparent;
    &:hover {
      border-color: transparent;
    }
  }
  &:has(img ~ span:empty) {
    span {
      display: none;
    }
  }
}
.material-icons {
  display: flex;
}
.button--small {
  height: 32px;
  padding: 6px 24px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.2px;
  .icon {
    width: 16px;
    display: inline-block;
    height: 16px;
    font-size: 16px;
  }
  i {
    height: 24px;
  }
}
.button--medium {
  height: 40px;
  padding: 8px 24px;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.2px;
  .icon {
    width: 20px;
    display: inline-block;
    height: 20px;
    font-size: 20px;
  }
  i {
    height: 24px;
  }
}
.button--large {
  height: 48px;
  padding: 12px 24px;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.2px;
  .icon {
    width: 24px;
    display: inline-block;
    height: 24px;
    font-size: 24px;
  }
  i {
    height: 24px;
  }
}
.button--x-large {
  height: 56px;
  padding: 16px 24px;
  font-size: 16px;
  letter-spacing: 0.2px;
  .icon {
    width: 24px;
    display: inline-block;
    height: 24px;
    font-size: 24px;
  }
  i {
    height: 24px;
    width: 24px;
  }
}
.button--square {
  border-radius: 4px;
  &.btn-shape-square {
    border-radius: 4px;
  }
}
.button--circle {
  border-radius: 40px;
  &.btn-shape-square {
    border-radius: 40px;
  }
}
.btn-shape-circle {
  border-radius: 40px;
  &.button--tertiary {
    border-radius: 0px;
    padding-left: 4px;
    padding-right: 4px;
  }
}
.btn-shape-square {
  border-radius: 4px;
  &.button--tertiary {
    border-radius: 0px;
    padding-left: 4px;
    padding-right: 4px;
  }
}
.button--primary {
  background-color: var(--prime-btn-bkgd);
  border: 0px solid var(--prime-btn-brdr);
  color: var(--prime-btn-text);
  &.button--undefined {
    &:disabled {
      background-color: var(--second-btn-bkgd-dsbl);
      border: 1px solid var(--second-btn-brdr-dsbl);
      color: var(--second-btn-text-dsbl);
    }
  }
  &:hover,
  &.Hover,
  &.Pressed {
    background-color: var(--prime-btn-bkgd-hover);
    border: 0px solid var(--prime-btn-brdr-hover);
    color: var(--prime-btn-text-hover);
    .icon {
      filter: var(--button-icon-primary-hover);
    }
    img {
      filter: var(--button-icon-primary-hover);
    }
  }
  .icon {
    filter: var(--button-icon-primary);
  }
  &.Caution {
    background-color: $error-text;
    border: 1px solid $error-text;
    color: $pcl-main-bkgd;
    &.button--undefined {
      background-color: $error-text;
      border: 1px solid $error-text;
      color: $pcl-main-bkgd;
      &:hover,
      &.is_hover {
        background-color: $icon-error;
        border: 1px solid $icon-error;
        color: $pcl-main-bkgd;
      }
      &:disabled {
        background-color: var(--second-btn-bkgd-dsbl);
        border: 1px solid var(--second-btn-brdr-dsbl);
        color: var(--second-btn-text-dsbl);
      }
    }
    &:hover,
    &.is_hover,
    &.Hover,
    &.Pressed {
      background-color: $icon-error;
      border: 1px solid $icon-error;
      color: $pcl-main-bkgd;
      .icon {
        filter: brightness(0) invert(1);
      }
      img {
        filter: brightness(0) invert(1);
      }
    }
    .icon {
      filter: brightness(0) invert(1);
    }
    img {
      filter: brightness(0) invert(1);
    }
    &:disabled,
    &.Disabled {
      background-color: var(--prime-btn-bkgd-dsbl);
      border: 1px solid var(--prime-btn-brdr-dsbl);
      color: var(--prime-btn-text-dsbl);
    }
  }
  &:disabled,
  &.Disabled {
    background-color: var(--prime-btn-bkgd-dsbl);
    border: 1px solid var(--prime-btn-brdr-dsbl);
    color: var(--prime-btn-text-dsbl);
    cursor: pointer;
    .icon {
      filter: var(--button-icon-disabled);
    }
  }
  &.Disabled {
    cursor: default;
    label {
      cursor: default;
    }
    .icon {
      filter: var(--button-icon-disabled);
    }
  }
}
.button--secondary {
  background: none;
  border: 1px solid var(--second-btn-brdr);
  color: var(--second-btn-text);
  box-sizing: border-box;
  &.button--undefined {
    background-color: var(--second-btn-bkgd);
    border: 1px solid var(--second-btn-brdr);
    color: var(--second-btn-text);
    img {
      filter: var(--button-icon-secondary);
    }
    &:hover,
    &.is_hover {
      img {
        filter: var(--button-icon-secondary-hover);
      }
    }
  }
  &.Hover,
  &:hover,
  &.Pressed {
    background: none;
    border: 1px solid var(--second-btn-brdr-hover);
    color: var(--second-btn-text-hover);
    .icon {
      filter: var(--button-icon-secondary-hover);
    }
  }
  .after-btn-icon,
  .before-btn-icon {
    filter: var(--button-icon-secondary);
  }
  .icon {
    filter: var(--button-icon-secondary);
  }
  &:hover {
    .after-btn-icon {
      filter: var(--button-icon-secondary-hover);
    }
  }
  &.is_hover {
    .after-btn-icon,
    .before-btn-icon {
      filter: var(--button-icon-secondary-hover);
    }
  }
  &.Caution {
    background-color: transparent;
    border: 1px solid $error-text;
    color: $error-text;
    .icon {
      color: $error-text;
      filter: brightness(0) saturate(100%) invert(16%) sepia(98%) saturate(5452%) hue-rotate(350deg) brightness(86%) contrast(99%);
    }
    &.button--undefined {
      background-color: var(--second-btn-bkgd);
      border: 1px solid $error-text;
      color: $error-text;
    }
    &.Hover,
    &:hover,
    &.Pressed {
      background-color: none;
      border: 1px solid $icon-error;
      color: $icon-error;
      img {
        filter: var(--button-icon-secondary-caution-hover);
      }
    }
    &:disabled,
    &.Disabled {
      background: none;
      background-color: transparent;
      border: 1px solid var(--second-btn-brdr-dsbl);
      color: var(--second-btn-text-dsbl);
      .icon {
        filter: var(--button-icon-disabled);
      }
    }
  }
  &:disabled,
  &.Disabled {
    border: 1px solid var(--second-btn-brdr-dsbl);
    color: var(--second-btn-text-dsbl);
    .icon {
      filter: var(--button-icon-disabled);
    }
  }
  &:disabled {
    .after-btn-icon,
    .before-btn-icon {
      filter: grayscale(100%) brightness(70%);
    }
  }
}
button {
  &.button--tertiary{
    background-color: var(--tertiary-btn-bkgd);
  border: 1px solid var(--tertiary-btn-brdr);
  color: var(--tertiary-btn-text);
  box-sizing: border-box;
  &:hover{
    border-bottom: 1px solid var(--tertiary-btn-brdr-hover-btm);
  }
  }
  &.button--undefined {
    background-color: var(--tertiary-btn-bkgd);
    border: 1px solid var(--tertiary-btn-brdr);
    color: var(--button-tertiary-text, var(--tertiary-btn-text));
    img {
      filter: var(--button-icon-tertiary);
    }
  }
  &:hover,
  &.is_hover,
  &.Hover,
  &.Pressed {
    //border-bottom: 1px solid var(--tertiary-btn-brdr-hover-btm);
    color: var(--tertiary-btn-text-hover);
    .icon {
      filter: var(--button-icon-tertiary-hover);
    }
  }
  &.button--tertiary {
    &.Default {
      &.Caution {
        .icon {
          color: $error-text;
          filter: brightness(0) saturate(100%) invert(11%) sepia(98%) saturate(3920%) hue-rotate(348deg) brightness(118%) contrast(102%);
        }
      }
    }
  }
  .after-btn-icon,
  .before-btn-icon {
    filter: var(--button-icon-tertiary);
  }
  .icon {
    filter: var(--button-icon-tertiary);
  }
  &.is_hover {
    .before-btn-icon {
      filter: var(--button-icon-tertiary-hover);
    }
  }
  &.Hover {
    .after-btn-icon {
      filter: var(--button-icon-tertiary-hover);
    }
  }
  &.Caution {
    background-color: var(--tertiary-btn-bkgd);
    border: 1px solid var(--tertiary-btn-brdr);
    color: $error-text;
    &:hover,
    &.is_hover,
    &.Hover,
    &.Pressed {
      border-bottom: 1px solid $icon-error;
      color: $icon-error;
    }
    .icon {
      filter: brightness(0) saturate(100%) invert(21%) sepia(68%) saturate(7215%) hue-rotate(348deg) brightness(85%) contrast(102%);
    }
    &:disabled,
    &.Disabled {
      background: none;
      background-color: transparent;
      border: 1px solid transparent;
      color: var(--tertiary-btn-text-dsbl);
      .icon {
        filter: brightness(0) saturate(100%) invert(83%) sepia(6%) saturate(0%) hue-rotate(191deg) brightness(87%) contrast(87%);
      }
    }
  }
  &.button--tertiary {
    &.Caution {
      &:hover,
      &.is_hover,
      &.Hover,
      &.Pressed {
        .icon {
          filter: brightness(0) saturate(100%) invert(9%) sepia(63%) saturate(6287%) hue-rotate(349deg) brightness(100%) contrast(100%);
        }
      }
    }
  }
  &:disabled,
  &.Disabled {
    color: var(--tertiary-btn-text-dsbl);
    .icon {
      filter: var(--button-icon-disabled);
    }
  }
  &:disabled {
    .after-btn-icon,
    .before-btn-icon {
      filter: grayscale(100%) brightness(70%);
    }
  }
}
.button--tertiary {
  &:disabled,
  &.Disabled,
  &[data-button-state='disabled'] {
    background: transparent;
    background-color: transparent;
    border: 1px solid transparent;
  }
}
.button--undefined {
  background-color: var(--prime-btn-bkgd);
  border: 1px solid var(--prime-btn-brdr);
  color: var(--prime-btn-text);
  display: inline-flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  img {
    width: 24px;
    height: 24px;
  }
  &:disabled {
    img {
      filter: grayscale(100%) brightness(70%);
    }
  }
}
